// extracted by mini-css-extract-plugin
export var noteTopRightButton = "Note-module--note-top-right-button--03a3e";